import React from "react";

// New signature money-green. Vibrant, slightly minty — pops on dark, glows
// beautifully, and doesn't feel neon-tacky. Single source of truth so bumps
// like this stay easy in the future.
export const BRAND_GREEN = "#3EE07C";
const BRAND_PURPLE = "#A855F7";

// Standalone logo mark — the rounded square with the chart tick.
// Use `variant="purple"` to render the Pro-tier purple version instead of green.
export const LogoIcon = ({ size = 20, className = "", glow = true, variant = "green" }) => {
  const fill = variant === "purple" ? BRAND_PURPLE : BRAND_GREEN;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={`${glow ? "brand-logo-glow" : ""} ${className}`}
      style={variant === "purple" ? { filter: glow ? "drop-shadow(0 0 4px rgba(168,85,247,0.55)) drop-shadow(0 0 14px rgba(168,85,247,0.22))" : "none" } : undefined}
    >
      <rect x="1" y="1" width="22" height="22" rx="7" fill={fill} />
      <path d="M6.5 12.5L10 9L13 12L17 8" stroke="#08080A" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="17" cy="8" r="1.6" fill="#08080A" />
    </svg>
  );
};

// Wordmark: logomark + "TradeGreen" text used in the sidebar and headers.
export const Wordmark = ({ theme, size = "md", variant = "green" }) => {
  const sizeClass = size === "sm" ? "text-base" : size === "lg" ? "text-3xl" : "text-lg";
  const iconSize = size === "sm" ? 18 : size === "lg" ? 32 : 24;
  const green = theme?.colors?.greenHero || BRAND_GREEN;
  const highlight = variant === "purple" ? BRAND_PURPLE : green;
  const bodyFont = theme?.fonts?.heading || "Geist";

  return (
    <div className={`inline-flex items-center gap-2.5 ${sizeClass}`} style={{ fontFamily: bodyFont, fontWeight: 700, letterSpacing: "-0.035em", color: theme?.colors?.textPrimary || "#FAFAFA" }}>
      <LogoIcon size={iconSize} variant={variant} />
      <span>
        Trade<span style={{ color: highlight }}>Green</span>
      </span>
    </div>
  );
};
